import Konva from 'konva';

const initialValues = {
    clinicName: '',
    address: '',
    city: '',
    zip: '',
    main: '',
    fax: '',
};
let canvasValues = initialValues;

let frontStage = null;
let frontBackgroundLayer = null;
let frontDataLayer = null;
let frontClinicNameText = null;
let frontAddressText = null;
let frontCityText = null;
let frontZipText = null;
let frontMainText = null;
let frontFaxText = null;
let frontLogo1Img = null;
let frontLogo2Img = null;
let frontLogo3Img = null;

let backStage = null;
let backBackgroundLayer = null;
let backDataLayer = null;

let UniversLT55RomanLoaded = false;
let UniversLT65BoldLoaded = false;
let fontsTries = 0;

let scale = 1.5;
let canvasWidth = 0;
let canvasHeight = 0;

export const setTemplateCodeCanvas = (code) => {
    canvasValues.templateCode = code;
}

export const checkFontsLoaded = () => {
    fontsTries++;
    if (fontsTries >= 25) {
        return true;
    }

    if (document.fonts.check('1rem LinotypeUniversLTPro65Bold')) {
        UniversLT55RomanLoaded = true;
    }
    if (document.fonts.check('1rem LinotypeUniversLTPro55Roman')) {
        UniversLT65BoldLoaded = true;
    }
    
    return UniversLT55RomanLoaded && UniversLT65BoldLoaded;
}

export const initTemplateCode = (code) => {
    canvasValues.templateCode = code;
}

export const initCanvas = () => {
    if (!checkFontsLoaded()) {
        setTimeout(() => {
            initCanvas();
        }, 100);
        return;
    }

    cleanCanvas();

    canvasValues.front = 1;
    canvasValues.back = 1;
    canvasValues.prevFront = '';
    canvasValues.prevBack = '';
    canvasValues.prevLogo = '';

    initFrontCanvas();
    initBackCanvas();
}

export const initFrontCanvas = () => {
    if (['p16bt12'].includes(canvasValues.templateCode)) {
        scale = 0.6;
        canvasWidth = 1100;
        canvasHeight = 850;
    }

    frontStage = new Konva.Stage({
        container: 'front-canvas',
        width: canvasWidth * scale,
        height: canvasHeight * scale
    });

    frontBackgroundLayer = new Konva.Layer();
    frontStage.add(frontBackgroundLayer);

    frontDataLayer = new Konva.Layer();
    frontDataLayer.moveUp();
    frontStage.add(frontDataLayer);

    let rect = new Konva.Rect({
        x: 0 * scale,
        y: 0 * scale,
        width: canvasWidth * scale,
        height: canvasHeight * scale,
        fill: '#ffffff',
    });
    frontBackgroundLayer.add(rect);

    if (canvasValues.templateCode === 'p16bt12') {
        initP16BT1FrontCanvas();
    }

    frontBackgroundLayer.batchDraw();
    frontDataLayer.batchDraw();
}

export const initP16BT1FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/brochures-files/p16bt1-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 1158 * scale,
            height: 908 * scale,
        });
        frontBackgroundLayer.draw();
    });

    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/brochures-files/p16bt1-background-low.png', (image) => {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontLogo2Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 1158 * scale,
            height: 908 * scale,
        });
        frontDataLayer.draw();
    });

    // Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/brochures-files/couple.png', (image) => {
    //     if (frontLogo2Img != null) {
    //         frontLogo2Img.destroy();
    //     }
    //     frontLogo2Img = image;

    //     frontDataLayer.add(image);
    //     image.setAttrs({
    //         x: (45 - 29) * scale,
    //         y: (337 - 29) * scale,
    //         width: 978 * 0.3354 * scale,
    //         height: 910 * 0.3354 * scale,
    //     });
    //     frontDataLayer.draw();
    // });

    // Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/brochures-files/people.png', (image) => {
    //     if (frontLogo3Img != null) {
    //         frontLogo3Img.destroy();
    //     }
    //     frontLogo3Img = image;

    //     frontDataLayer.add(image);
    //     image.setAttrs({
    //         x: (484 - 29) * scale,
    //         y: (18 - 29) * scale,
    //         width: 1972 * 0.3346 * scale,
    //         height: 1252 * 0.3346 * scale,
    //     });
    //     frontDataLayer.draw();
    // });

    // let webText = new Konva.Text({
    //     text: 'UTPhysicians.com',
    //     fontSize: convertPointsToPixels(11) * scale,
    //     fontFamily: 'LinotypeUniversLTPro55Roman',
    //     x: 380 * scale,
    //     y: 662 * scale,
    //     fill: '#231F20',
    //     width: 332 * scale,
    //     align: 'center',
    // });
    // frontDataLayer.add(webText);

    // let phoneText = new Konva.Text({
    //     text: '888-4UT-DOCS (888-488-3627)',
    //     fontSize: convertPointsToPixels(11) * scale,
    //     fontFamily: 'LinotypeUniversLTPro55Roman',
    //     x: 380 * scale,
    //     y: 682 * scale,
    //     fill: '#231F20',
    //     width: 332 * scale,
    //     align: 'center',
    // });
    // frontDataLayer.add(phoneText);

    drawFrontVariablesP16BT1();
}

export const drawFrontVariablesP16BT1 = () => {
    frontClinicNameText = new Konva.Text({
        text: canvasValues.clinicName,
        fontSize: convertPointsToPixels(11) * scale,
        fontFamily: 'LinotypeUniversLTPro65Bold',
        x: 380 * scale,
        y: 562 * scale,
        fill: '#231F20',
        width: 332 * scale,
        align: 'center',
    });
    frontDataLayer.add(frontClinicNameText);

    frontAddressText = new Konva.Text({
        text: canvasValues.address,
        fontSize: convertPointsToPixels(11) * scale,
        fontFamily: 'LinotypeUniversLTPro55Roman',
        x: 380 * scale,
        y: 582 * scale,
        fill: '#231F20',
        width: 332 * scale,
        align: 'center',
    });
    frontDataLayer.add(frontAddressText);

    frontCityText = new Konva.Text({
        text: canvasValues.city + ', TX ' + canvasValues.zip,
        fontSize: convertPointsToPixels(11) * scale,
        fontFamily: 'LinotypeUniversLTPro55Roman',
        x: 380 * scale,
        y: 602 * scale,
        fill: '#231F20',
        width: 332 * scale,
        align: 'center',
    });
    frontDataLayer.add(frontCityText);

    let phone = [];
    if (canvasValues.main !== '') {
        phone.push(canvasValues.main + ' main');
    }
    if (canvasValues.fax !== '') {
        phone.push(canvasValues.fax + ' fax');
    }

    frontMainText = new Konva.Text({
        text: phone.join(' | '),
        fontSize: convertPointsToPixels(11) * scale,
        fontFamily: 'LinotypeUniversLTPro55Roman',
        x: 380 * scale,
        y: 622 * scale,
        fill: '#231F20',
        width: 332 * scale,
        align: 'center',
    });
    frontDataLayer.add(frontMainText);
}

export const destroyFrontVariablesP16BT1 = () => {
    if (frontClinicNameText) {
        frontClinicNameText.destroy();
    }
    if (frontAddressText) {
        frontAddressText.destroy();
    }
    if (frontCityText) {
        frontCityText.destroy();
    }
    if (frontZipText) {
        frontZipText.destroy();
    }
    if (frontMainText) {
        frontMainText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
}

export const initBackCanvas = () => {
    
}

export const createImage = (options) => {
    let imageObj = new Image();
    imageObj.onload = function () {
        let ref = options.ref;
        if (ref == null) {
            ref = { current: null };
        }

        ref.current = new Konva.Image({
            width: options.width * options.scale * scale,
            height: options.height * options.scale * scale,
            image: imageObj,
            x: options.x * scale,
            y: options.y * scale,
            // draggable: true,
        });
        // ref.current.on('dragend', function (e) {
        //     console.log(e.target.attrs.x, e.target.attrs.y)
        // });

        options.layer.add(ref.current);
        options.layer.batchDraw();
    };
    imageObj.crossOrigin = 'Anonymous';
    imageObj.src = 'https://' + process.env.REACT_APP_VDP_S3_BUCKET + '.s3.amazonaws.com/' + options.url;
}

export const changeClinicNameAll = (value) => {
    canvasValues.clinicName = value;
    redrawFront();
    redrawBack();
}

export const changeAddressAll = (value) => {
    canvasValues.address = value;
    redrawFront();
    redrawBack();
}

export const changeCityAll = (value) => {
    canvasValues.city = value;
    redrawFront();
    redrawBack();
}

export const changeZipAll = (value) => {
    canvasValues.zip = value;
    redrawFront();
    redrawBack();
}

export const changeMainAll = (value) => {
    canvasValues.main = value;
    redrawFront();
    redrawBack();
}

export const changeFaxAll = (value) => {
    canvasValues.fax = value;
    redrawFront();
    redrawBack();
}

export const getCanvasValues = () => {
    return canvasValues;
}

export const convertPointsToPixels = (points) => {
    return points * 4 / 3 + 0.5;
}

export const getCanvasFrontDataUrl = (ratio = 1) => {
    if (frontStage == null) {
        return null;
    }

    return frontStage.toDataURL({ pixelRatio: ratio });
}

export const getCanvasBackDataUrl = (ratio = 1) => {
    if (backStage == null) {
        return null;
    }

    return backStage.toDataURL({ pixelRatio: ratio });
}

export const redrawFront = () => {
    if (frontDataLayer == null) {
        return;
    }

    if (canvasValues.templateCode === 'p16bt12') {
        destroyFrontVariablesP16BT1();
        drawFrontVariablesP16BT1();
    }

    frontDataLayer.batchDraw();
}

export const redrawBack = () => {
    if (backDataLayer == null) {
        return;
    }

    backDataLayer.batchDraw();
}

export const isEmpty = (element) => {
    if (typeof element == 'undefined' || !element || element === '') {
        return true;
    }
    return false;
}

export const cleanCanvas = () => {
    if (frontLogo1Img != null) {
        frontLogo1Img.destroy();
    }
    if (frontLogo2Img != null) {
        frontLogo2Img.destroy();
    }
    if (frontLogo3Img != null) {
        frontLogo3Img.destroy();
    }
    if (frontStage != null) {
        frontStage.destroy();
        frontStage.batchDraw();
    }
    if (backStage != null) {
        backStage.destroy();
        backStage.batchDraw();
    }
    if (frontBackgroundLayer != null) {
        frontBackgroundLayer.destroy();
        frontBackgroundLayer.batchDraw();
    }
    if (frontDataLayer != null) {
        frontDataLayer.destroy();
        frontDataLayer.batchDraw();
    }
    if (backBackgroundLayer != null) {
        backBackgroundLayer.destroy();
        backBackgroundLayer.batchDraw();
    }
    if (backDataLayer != null) {
        backDataLayer.destroy();
        backDataLayer.batchDraw();
    }
}

export const createText = (fontFamily, fontSize, text, x, y, color = '#000', letterSpacing = null) => {
    return new Konva.Text({
        text: text,
        fontSize: convertPointsToPixels(fontSize) * scale,
        fontFamily: fontFamily,
        x: x * scale,
        y: y * scale,
        fill: color,
        letterSpacing: letterSpacing * scale,
    });
}